import React from 'react';
import { Box, Typography } from '@mui/material';

const InfinityLogo = ({ size = 48, variant = 'badge' }) => {
  const mark = (
    <Typography
      sx={{
        fontSize: size,
        fontWeight: 800,
        lineHeight: 1,
        position: 'relative',
        zIndex: 1,
        background: 'linear-gradient(120deg, #a855f7 0%, #6366f1 40%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textShadow: '0 0 16px rgba(168,85,247,0.7)',
        animation: 'flicker 3.2s ease-in-out infinite',
        '@keyframes flicker': {
          '0%, 100%': { opacity: 1 },
          '45%': { opacity: 0.85 },
          '55%': { opacity: 1 },
        },
      }}
    >
      ∞
    </Typography>
  );

  if (variant === 'icon') {
    return (
      <Box
        component="span"
        sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
        aria-label="InfiniMVP logo"
      >
        {mark}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: size + 12,
        height: size + 12,
        display: 'grid',
        placeItems: 'center',
        borderRadius: '14px',
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.2)',
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: -20,
          background:
            'conic-gradient(from 0deg, rgba(168,85,247,0.2), rgba(99,102,241,0.5), rgba(236,72,153,0.4), rgba(168,85,247,0.2))',
          filter: 'blur(12px)',
          opacity: 0.8,
          animation: 'pulseGlow 2.8s ease-in-out infinite',
        },
        '@keyframes pulseGlow': {
          '0%, 100%': { opacity: 0.5, transform: 'scale(0.95)' },
          '50%': { opacity: 1, transform: 'scale(1.05)' },
        },
      }}
      aria-label="InfiniMVP logo"
    >
      {mark}
    </Box>
  );
};

export default InfinityLogo;
